import { BookingResponse } from '../Components/Popups/ConfirmPopup';
import { TimeSheet } from '../Pages/Dashboard/Dashboard';
import { apiRequest } from './api';

export const getBookings = () => {
  return apiRequest<TimeSheet[]>({
    method: 'GET',
    url: '/bookings',
  });
};

interface ConfirmBookingPayload {
  PONumber: string;
}

export const confirmBooking = (bookingId: string, payload: ConfirmBookingPayload) => {
  return apiRequest({
    method: 'POST',
    url: `/bookings/${bookingId}/confirm`,
    data: payload,
  });
};

export const getBookingById = (bookingId: string | number) => {
  return apiRequest<BookingResponse>({
    method: 'GET',
    url: `/bookings/${bookingId}`,
  });
};

interface DisputeBookingPayload {
  PONumber: string;
  Reason: string;
}

export const disputeBooking = (bookingId: string, payload: DisputeBookingPayload) => {
  return apiRequest<void>({
    method: 'POST',
    url: `/bookings/${bookingId}/dispute`,
    data: payload,
  });
};

interface FeedbackPayload {
  Rating?: number;
  Feedback?: string;
}

export const submitBookingFeedback = (bookingId: string, payload: FeedbackPayload) => {
  return apiRequest<void>({
    method: 'PATCH',
    url: `/bookings/${bookingId}`,
    data: payload,
  });
};

